import angular from 'angular';

/* @ngInject */
export default function MatchDefinitionsFilter() {
    return function (items, filteredDefinition) {
        if (!filteredDefinition.isFiltered) {
            return items;
        }

        const results = [];
        let foundedDefinition;
        angular.forEach(items, function (item) {
            foundedDefinition = undefined;
            for (let i = 0; i < filteredDefinition.definitions.length; ++i) {
                if (item.id === filteredDefinition.definitions[i].id) {
                    foundedDefinition = filteredDefinition.definitions[i];
                    break;
                }
            }
            if (foundedDefinition !== undefined) {
                results.push(item);
            }
        });
        return results;
    };
}
